import { Routes, Route } from "react-router-dom";
import { IS_DEV } from "./lib/env.ts";
import Landing from "./screens/Landing.tsx";
import InvitePage from "./screens/InvitePage.tsx";
import Onboarding from "./screens/Onboarding.tsx";
import Dashboard from "./screens/Dashboard.tsx";
import BlendScreen from "./screens/BlendScreen.tsx";
import AuthCallback from "./screens/AuthCallback.tsx";
import PublicProfile from "./screens/PublicProfile.tsx";
import Privacy from "./screens/Privacy.tsx";
import NotFound from "./screens/NotFound.tsx";
import DevStates from "./screens/DevStates.tsx";
import DevBlend from "./screens/DevBlend.tsx";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/with/:shareSlug" element={<InvitePage />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/me" element={<Dashboard />} />
      <Route path="/b/:blendSlug" element={<BlendScreen />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/privacy" element={<Privacy />} />
      {IS_DEV && <Route path="/dev/states" element={<DevStates />} />}
      {IS_DEV && <Route path="/dev/blend" element={<DevBlend />} />}
      {/* Public taste profiles: twoshot.xyz/<letterboxd-username>. Ranked below
          all static routes by React Router, so /me, /onboarding, etc. always win. */}
      <Route path="/:username" element={<PublicProfile />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
